/**
 * BALANS HOLATI — front tomonidagi YAGONA ko'rsatish qatlami (#66).
 *
 * Hisob-kitob butunlay backendda (`backend/src/lib/balance.ts`) — bu yerda faqat
 * "holat → rang / tarjima kaliti" xaritasi va javob shakli turadi.
 *
 * NEGA ALOHIDA FAYL: rang xaritasi ilgari faqat `components/BalancesPanel.tsx`
 * ichida edi. Balans endi o'quvchi va ota-ona kartochkalarida ham ko'rinadi —
 * nusxa ko'chirilsa, bitta joyda rang o'zgarganda uchta ekranda uch xil "Qarzdor"
 * bo'lib qolardi.
 */

/** Holatlar — backend `BALANCE_STATUSES` bilan AYNI tartibda (chiplar shu ketma-ketlikda). */
export const BALANCE_STATUSES = ['PAID', 'PARTIAL', 'DEBT', 'OVERPAID'] as const;

export type BalanceStatus = (typeof BALANCE_STATUSES)[number];

/** Holat rangi (Mantine token) — badge, chip va matn ranglari shu yerdan. */
export const BALANCE_STATUS_COLOR: Record<BalanceStatus, string> = {
  PAID: 'teal',
  PARTIAL: 'yellow',
  DEBT: 'red',
  OVERPAID: 'blue',
};

/** Tarjima kaliti (`locales.ts` → `balanceStatus.*`). */
export function balanceStatusKey(s: BalanceStatus): string {
  return `balanceStatus.${s}`;
}

/** GET /reports/balances (va /reports/balances/students) qatori. */
export interface BalanceRow {
  studentId: string;
  fullName: string;
  classId: string | null;
  className: string | null;
  /** false — to'lov rejasi yo'q, lekin shu oyda to'lov qilgan (backend izohiga qarang). */
  hasPlan: boolean;
  /** Reja = oylik − chegirma (chegirma ALLAQACHON ayrilgan). */
  due: number;
  paid: number;
  debt: number;
  overpaid: number;
  /** paid − due (musbat — ortiqcha, manfiy — qarz). */
  balance: number;
  status: BalanceStatus;
  /** Rejadagi chegirma (xom maydon) — `due` ichida jim ayrilgani ko'rinib tursin. */
  discount: number;
}

/** Bir yoki bir nechta o'quvchi bo'yicha balans javobi (GET /reports/balances/students). */
export interface StudentBalancesResp {
  month: string;
  items: BalanceRow[];
}
